/* eslint-disable babel/camelcase */
import React, { useState, useRef } from "react";
// import { postToRails } from 'venuescanner-js/services/api'
import PropTypes from "prop-types";
import cl from "classnames";
import classes from "./styles.module.scss";
import ErrorPage from "venuescanner-js/react/components/ErrorPage";
import Form from "venuescanner-js/react/components/Form/Form";
import Password from "venuescanner-js/react/components/Form/Fields/Password/FormInput";
import Input from "venuescanner-js/react/components/Form/Fields/Input/FormInput";
import Phone from "venuescanner-js/react/components/Form/Fields/Phone/FormInput";
import Row from "venuescanner-js/react/components/Form/Row";
import CenteredRow from "venuescanner-js/react/components/Form/CenteredRow";
import { registerValidation } from "venuescanner-js/validation/profile";
import Submit from "venuescanner-js/react/components/Form/button/Submit";
import LinkButton from "venuescanner-js/react/components/Buttons/LinkButton";
import Loading from "venuescanner-js/react/components/Loading";
import Confirmation from "venuescanner-js/react/components/Form/Notifications/Confirmation";
import Radio from "venuescanner-js/react/components/Form/Fields/Radio/FormRadio";
import Toggle from "venuescanner-js/react/components/Form/Fields/Toggle/FormInput";
import Message from "venuescanner-js/react/components/Form/Notifications/Message";
import Location from "venuescanner-js/react/components/Form/Fields/Location/FormInput";
// import ErrorMessage from 'venuescanner-js/react/components/Form/Notifications/ErrorMessage'
import TemporaryWarning, {
  TemporaryWarningTrigger,
} from "venuescanner-js/react/components/Form/Notifications/TemporaryWarning";
// import ForgotPassword from './ForgotPassword'
import { authService } from "venuescanner-js/services/auth";
import CustomEvents, { Events } from "venuescanner-js/services/windowEvents";
import { signUp } from "venuescanner-js/services/auth/post";
import { reportError } from "venuescanner-js/react/services/errorService";

const hasLoggedIn = () => {
  CustomEvents[Events.loggedIn](authService.user); // triggers logged in events
};
const emptyData = {
  email: "",
  phone: "",
  newpassword: "",
  confirmpassword: "",
  name: "",
  lastName: "",
  marketing: "",
  user_type: "",
  agree: "",
  promo: "",
  place: "",
};
const Register = ({ sent, showLogin }) => {
  const formContainer = useRef(null);
  const [updating, setUpdating] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [failedMessage, setFailedMessage] = useState(null);
  const [invalidEmitter] = useState(new TemporaryWarningTrigger());
  // const [passwordChanged, setPasswordChanged] = useState(false)
  const handleRegisterChange = (...args) => {
    console.log(args);
    // setUpdatedPassword(false)
    // setPasswordChanged(true)
  };
  const handleRegisterSubmit = (values, { resetForm }) => {
    const {
      email,
      phone,
      newpassword,
      confirmpassword,
      name,
      lastName,
      marketing,
      user_type,
      // agree,
      promo,
      place,
    } = values;

    // console.log(values)
    setUpdating(true);
    signUp({
      email,
      phone,
      password: newpassword,
      confirmPassword: confirmpassword,
      name,
      lastName,
      main_signup_marketing: marketing,
      user_type,
      // agree,
      promo,
      place,
    }).then(({ data, status, errors }) => {
      // setPasswordChanged(false)
      // console.log({ data, status, errors })
      setUpdating(false);
      if (!status) {
        // failed to update
        const errorMessage =
          errors.email ||
          (errors.length
            ? errors[0].message || errors[0]
            : "Unable to Sign up with the given information");
        setFailedMessage(errorMessage);
        invalidEmitter.show();
      } else {
        resetForm({});
        setLoggedIn(true);
        hasLoggedIn();
        if (sent) sent(data);
      }
    });
  };
  return (
    <div ref={formContainer} className={classes.register}>
      <Form
        initialValues={emptyData}
        validation={registerValidation}
        handleSubmit={handleRegisterSubmit}
        handleChange={handleRegisterChange}
        // handleValidationError={console.log}
      >
        <div>
          Already a member? <LinkButton onClick={showLogin}>Sign in</LinkButton>
        </div>
        <div
          className={cl(
            { [classes.completed]: loggedIn },
            classes.register__form
          )}
        >
          <Row>
            <Input label="First name" name="name" />
            <Input label="Last name" name="lastName" />
          </Row>
          <Row>
            <Input label="Email" name="email" type="email" />
            <Phone label="Phone †" name="phone" />
          </Row>
          <Row>
            <Location
              name="place"
              label="Where are you based?"
              locationKey="placeData"
              inputStyles={true}
            />
            <Input label="Promo code" name="promo" />
          </Row>
          <Row>
            <Password label="Password" name="newpassword" />
            <Password label="Confirm password" name="confirmpassword" />
          </Row>
        </div>

        <CenteredRow>
          <Row>
            <Radio
              label="Select your user type"
              name="user_type"
              options={[
                { value: "organiser", label: "Event Organiser" },
                { value: "host", label: "Venue Host" },
              ]}
            />
          </Row>
          <Row>
            <div>
              I’d love to hear about top tips, offers &amp; rewards (see{" "}
              <a href="/terms-and-conditions" target="_blank">
                privacy policy
              </a>
              )
            </div>
            <Radio
              name="marketing"
              options={[
                { value: "on", label: "Yes please" },
                { value: "off", label: "No thanks", cross: true },
              ]}
            />
            <Message name="marketing" value="off">
              You will not receive marketing emails. Only emails that are
              regarding your enquiry activity.
            </Message>
          </Row>
          <Row>
            <div>
              I agree to the{" "}
              <a href="/terms-and-conditions" target="_blank">
                Terms &amp; Conditions
              </a>
            </div>
            <Toggle name="agree" />
          </Row>
        </CenteredRow>
        <div className={classes["cta-area"]}>
          <TemporaryWarning
            message={failedMessage}
            eventEmitter={invalidEmitter}
            closeButton={true}
            duration={20000}
          />
          {updating ? (
            <Loading>Logging in...</Loading>
          ) : (
            <Submit visible={!loggedIn}>Sign up</Submit>
          )}
        </div>
        <div
          className={cl(
            { [classes.completed]: loggedIn },
            classes.login__confirmation
          )}
        >
          <Confirmation>You are now signed in</Confirmation>
        </div>
      </Form>
    </div>
  );
};

Register.propTypes = {
  sent: PropTypes.func,
  showLogin: PropTypes.func,
};

class ErrorBoundary extends React.Component {
  state = {
    error: null,
    errorInfo: null,
  };

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    reportError("SignIn - Register", error, errorInfo);
  }

  render() {
    const { state, props } = this;
    if (state.error) {
      return <ErrorPage />;
    }
    return <Register {...props} />;
  }
}
export default ErrorBoundary;
